import { useContext } from 'react';
import TranslatorPropsContext from './TranslatorPropsContext';

/**
 * Translator hook: to use with function components.
 */
var useTranslator = function useTranslator() {
  return useContext(TranslatorPropsContext);
};
export default useTranslator;